import {Mask} from './Mask';
import {MaskImpl} from './MaskImpl';

export class MaskMobilePrefixNumberRus extends MaskImpl implements Mask {

    public normalize(value: string): string {
        if (!value || value == '+') {
            return '+7';
        }
        return '+7' + value.toString().replace(/[^\d]/g, '').slice(1, 11);
    }

}
